import { render, staticRenderFns } from "./Attach.vue?vue&type=template&id=1437fc5f&scoped=true&"
import script from "./Attach.vue?vue&type=script&lang=js&"
export * from "./Attach.vue?vue&type=script&lang=js&"
import style0 from "./Attach.vue?vue&type=style&index=0&id=1437fc5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1437fc5f",
  null
  
)

export default component.exports